import { Badge } from "react-bootstrap";
import moment from "moment";
import SidebarLink from "views/SidebarFragments/SidebarLink";
import { useModuleEnabled } from "redux/selectors/modules";
import { ConfirmationContext } from "modules/pricingv2/context";
import { ConfirmationProvider } from "modules/pricingv2/cards/Confirmation";
import { RiRefreshLine } from "react-icons/ri";
import { FaCcAmazonPay } from "react-icons/fa";
import { MdManageSearch } from "react-icons/md";
import { MdOutlineTimeline } from "react-icons/md";
import { useAppSelector } from "../../redux/hooks";
import { useFetch } from "../../hooks/api";

const PricingSidebar = ({ small = false }) => {
  const user = useAppSelector((state) => state.user);
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const hasForecastModule = useModuleEnabled("FORECAST");

  const isActive = (routeName) => {
    return document.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const buyBoxStatsQuery = useFetch(
    ["buyboxStats", marketPlace.marketPlace, user?.organization_id],
    `/pricing/buybox/stats`,
    {
      market_place: marketPlace.marketPlace,
    },

    {
      default: [],
      select: (data) => data?.data?.data?.length,
    },
  );

  const now = moment();
  const tosDate = moment(user?.tos_acceptance_date?.slice(0, 10));
  const daysSinceSignup = tosDate ? now.diff(tosDate, "days") : 100;

  const endpoint = "/user/_pricing/dashboard";

  return (
    <>
      <SidebarLink
        isActive={isActive("/user/_pricing/dashboard") || isActive("/user/_pricing/category")}
        to={`${endpoint}`}
        icon={<i className="pe-7s-cash" />}
        small={small}
        section={"pricing"}
      >
        Dynamic Pricing{" "}
        {user.tier === "unknown" && user.pricing_tier === "unknown" && daysSinceSignup < 3 && (
          <Badge
            className={`badge badge-${isActive(endpoint) ? "secondary" : "primary"}`}
            pill
            style={{ marginLeft: "1rem" }}
          >
            NEW
          </Badge>
        )}
      </SidebarLink>
      <SidebarLink
        isActive={isActive(`/user/_pricing/forecast`)}
        to={`/user/_pricing/forecast`}
        icon={
          <span className="fs-2">
            <MdOutlineTimeline style={{ color: "#2e0054" }} />
          </span>
        }
        small={small}
        section={"pricing"}
        isVisible={hasForecastModule}
      >
        Forecast Dashboard
      </SidebarLink>
      <SidebarLink
        isActive={isActive(`/user/_pricing/management`) || isActive("/user/_pricing/plan")}
        to={`/user/_pricing/management`}
        icon={
          <span className="fs-2">
            <MdManageSearch style={{ color: "#2e0054" }} />
          </span>
        }
        small={small}
        section={"pricing"}
      >
        Management
      </SidebarLink>
      <SidebarLink
        isActive={isActive(`/user/_pricing/configuration`)}
        to={`/user/_pricing/configuration`}
        icon={<i className="fa fa-cog" />}
        small={small}
        section={"pricing"}
      >
        Configuration
      </SidebarLink>

      <SidebarLink
        isActive={isActive(`/user/_pricing/changes`)}
        to={`/user/_pricing/changes`}
        icon={
          <span className="fs-3">
            <RiRefreshLine style={{ color: "#2e0054" }} />
          </span>
        }
        small={small}
        section={"pricing"}
      >
        Price Logs
        <ConfirmationProvider marketPlace={marketPlace} date={now} count={true} limit={100}>
          <ConfirmationContext.Consumer>
            {({ confirmations, isLoading }) => {
              const confirmationCnt = confirmations?.length || 0;
              return (
                <Badge className={`badge badge-secondary`} pill style={{ marginLeft: "1rem" }}>
                  {isLoading ?
                    "..."
                  : confirmationCnt >= 20 ?
                    "20+"
                  : confirmationCnt}
                </Badge>
              );
            }}
          </ConfirmationContext.Consumer>
        </ConfirmationProvider>
      </SidebarLink>

      <SidebarLink
        isActive={isActive(`/user/_pricing/buybox`)}
        to={`/user/_pricing/buybox`}
        icon={
          <span className="fs-3">
            <FaCcAmazonPay style={{ color: "#2e0054" }} />
          </span>
        }
        small={small}
        section={"pricing"}
        isVisible={channel === "amazon"}
      >
        Buy Box Health
        <Badge className={`badge badge-secondary`} pill style={{ marginLeft: "1rem" }}>
          {buyBoxStatsQuery.isLoading ?
            "..."
          : buyBoxStatsQuery.data >= 20 ?
            "20+"
          : buyBoxStatsQuery.data}
        </Badge>
      </SidebarLink>
    </>
  );
};

export default PricingSidebar;
